import script from "./University.vue?vue&type=script&setup=true&lang=ts"
export * from "./University.vue?vue&type=script&setup=true&lang=ts"

import "./University.vue?vue&type=style&index=0&id=45d00da6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d00da6"]])

export default __exports__